import React from 'react';
import { Star, Heart, Users, GraduationCap, Baby } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-white py-16 px-4 relative" data-id="element-246">
      <div className="max-w-6xl mx-auto" data-id="element-247">
        {/* Trust Header */}
        <div className="text-center mb-16" data-id="element-248">
          <div className="flex justify-center items-center gap-1 mb-2" data-id="element-249">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-6 h-6 text-yellow-400 fill-yellow-400" data-id="element-250" />)}
          </div>
          <h3 className="text-xl font-bold text-gray-600 mb-2" data-id="element-251">
            4.9/5 basado en reseñas de padres reales
          </h3>
          <p className="text-3xl md:text-4xl font-black text-gray-800" data-id="element-252">
            Más de <span className="text-orange-500" data-id="element-253">1,500 familias</span> ya
            confían en nosotros
          </p>
        </div>

        <h2 className="text-3xl md:text-5xl font-black text-center text-gray-900 mb-12" data-id="element-254">
          ¿Para quién es este{' '}
          <span className="relative inline-block text-blue-500" data-id="element-255">
            Mega Pack
            <svg className="absolute w-full h-3 -bottom-1 left-0 text-yellow-200 -z-10" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-256">
              <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="8" fill="none" data-id="element-257" />
            </svg>
          </span>
          ?
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-258">
          {/* Card 1: Madres Primerizas */}
          <motion.div whileHover={{
          y: -10
        }} className="bg-pink-50 p-6 rounded-3xl border-2 border-pink-100 text-center shadow-lg" data-id="element-259">
            <div className="bg-white w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4 shadow-md border-2 border-pink-200" data-id="element-260">
              <Baby className="w-10 h-10 text-pink-500" data-id="element-261" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-262">
              Madres Primerizas
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-263">
              Que buscan herramientas prácticas para estimular a sus pequeños
              desde casa sin complicaciones.
            </p>
          </motion.div>

          {/* Card 2: Padres */}
          <motion.div whileHover={{
          y: -10
        }} className="bg-blue-50 p-6 rounded-3xl border-2 border-blue-100 text-center shadow-lg" data-id="element-264">
            <div className="bg-white w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4 shadow-md border-2 border-blue-200" data-id="element-265">
              <Users className="w-10 h-10 text-blue-500" data-id="element-266" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-267">
              Padres Ocupados
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-268">
              Que quieren calidad de tiempo con sus hijos pero necesitan
              actividades listas para usar.
            </p>
          </motion.div>

          {/* Card 3: Maestros */}
          <motion.div whileHover={{
          y: -10
        }} className="bg-green-50 p-6 rounded-3xl border-2 border-green-100 text-center shadow-lg" data-id="element-269">
            <div className="bg-white w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4 shadow-md border-2 border-green-200" data-id="element-270">
              <GraduationCap className="w-10 h-10 text-green-500" data-id="element-271" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-272">Maestros</h3>
            <p className="text-gray-600 text-sm" data-id="element-273">
              Que buscan material didáctico fresco, divertido y educativo para
              sus clases de preescolar y primaria.
            </p>
          </motion.div>

          {/* Card 4: Familias */}
          <motion.div whileHover={{
          y: -10
        }} className="bg-yellow-50 p-6 rounded-3xl border-2 border-yellow-100 text-center shadow-lg" data-id="element-274">
            <div className="bg-white w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4 shadow-md border-2 border-yellow-200" data-id="element-275">
              <Heart className="w-10 h-10 text-yellow-500" data-id="element-276" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-277">
              Familias Unidas
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-278">
              Que desean desconectarse de las pantallas y reconectarse entre
              ellos a través del juego.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}